export class HoriznotalTimeSpan {
    start: Date;
    end: Date;
    status: string;
    backgroundColor: string;
    width: number;
    marker: HorizontalTimelineMarker;
    spanTooltipText: string;

    constructor(start: Date, end: Date, status: string, backgroundColor: string, spanTooltipText: string) {
        this.start = start;
        this.end = end;
        this.status = status;
        this.backgroundColor = backgroundColor;
        this.spanTooltipText = spanTooltipText;
    }
}

export class HorizontalTimelineMarker {
    date: Date;
    markerTooltipData: string;
    cssClass: string;
    markerWidthPercentage?: number;
}
